import { render, staticRenderFns } from "./CompanyIdUploader.vue?vue&type=template&id=69a31cd9&scoped=true&"
import script from "./CompanyIdUploader.vue?vue&type=script&lang=js&"
export * from "./CompanyIdUploader.vue?vue&type=script&lang=js&"
import style0 from "./CompanyIdUploader.vue?vue&type=style&index=0&id=69a31cd9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a31cd9",
  null
  
)

export default component.exports